import { Box, Typography } from '@mui/material';

import { Logo } from './Logo';

export const BrandNameWithLogo = ({
  fontSize = 24,
  gap = 1,
  showLogoOnly = false,
}: {
  fontSize?: number;
  gap?: number;
  showLogoOnly?: boolean;
}) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Logo height={fontSize} width="auto" mr={showLogoOnly ? 0 : gap} />
      {!showLogoOnly && (
        <Typography
          variant="h3"
          fontSize={fontSize}
          noWrap
          fontFamily="Limelight"
          color="text.primary"
        >
          Billx
        </Typography>
      )}
    </Box>
  );
};
